import styled from 'styled-components';

export const Container = styled.div`
    font-family: 'Poppins', sans-serif;
    font-size: 1.875rem; /* 30px */
    font-weight: 600;
    color: #254d6b;
    line-height: 1.3;
    letter-spacing: -0.01em;
    margin-bottom: 1.5rem;

    @media screen and (max-width: 768px) {
        font-size: 1.5rem; /* 24px */
    }

    @media screen and (max-width: 480px) {
        font-size: 1.25rem; /* 20px */
    }
`;